<template>
  <footer class="footer page-footer">
    <div class="content">
      <div class="container">
        <div class="columns">
          <div class="column is-3">
            <img
              class="logo"
              src="@/assets/sonata-logo.svg"
              alt="Sonata"
              width="112"
              height="30"
            >
            <p>
              <strong>Sonata Sync Ltd</strong> is a company registered in England and Wales (11739072).
            </p>
            <p>
              <a href="https://soundscapeagency.com/">
                <img
                  src="@/assets/soundscape-dark.png"
                  alt="Soundscape Agency"
                  width="108"
                  height="19"
                >
              </a>
              <br>
              Sonata is a partner company of <a href="https://soundscapeagency.com/">Soundscape Agency</a>.
            </p>
          </div>
          <div class="column is-2 is-offset-1">
            <h4 class="title is-4">
              Navigation
            </h4>
            <p>
              <router-link :to="{ name: 'home' }">
                Home
              </router-link>
              <br>
              <router-link :to="{ name: 'track-search' }">
                Tracks
              </router-link>
              <br>
              <router-link :to="{ name: 'playlist-list' }">
                Playlists
              </router-link>
              <br>
              <router-link :to="{ name: 'pricing' }">
                Pricing
              </router-link>
              <br>
              <router-link :to="{ name: 'faq' }">
                FAQ
              </router-link>
              <br>
              <router-link :to="{ name: 'artist-submissions' }">
                <strong>Become a Sonata artist</strong>
              </router-link>
            </p>
          </div>
          <div class="column is-2 is-offset-1">
            <h4 class="title is-4">
              Legal
            </h4>
            <p>
              <router-link :to="{ name: 'user-terms' }">
                Terms
              </router-link>
              <br>
              <a
                href="https://www.iubenda.com/privacy-policy/14330431"
                title="Privacy Policy"
              >Privacy Policy</a>
              <br>
              <a
                href="https://www.iubenda.com/privacy-policy/14330431/cookie-policy"
                title="Cookie Policy"
              >Cookie Policy</a>
            </p>
          </div>
          <div class="column is-2 is-offset-1">
            <h4 class="title is-4">
              Contact
            </h4>
            <p>
              <a href="mailto:hello@sonata.media">
                <span
                  class="icon-static mail"
                  style="margin: -4px 0 -4px 0;"
                />
                hello@sonata.media
              </a>
            </p>
            <p>
              <a href="https://www.instagram.com/sonata.media/">
                <span
                  class="icon-static instagram"
                  style="margin: -4px 0 -4px 0;"
                />
                sonata.media
              </a>
            </p>
            <p>
              10 Dock Street
              <br>London
              <br>E1 8JP
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

footer.page-footer {
  background: $white;
  color: $bluegrey3;
  p { color: $bluegrey3; }
  .logo {
    margin-bottom: 12px;
  }
}
</style>
